<template>
  <v-row no-gutters justify="center" align="start" class="pt-6">
    <div class="pa-6" style="max-width: 600px;">
      <v-row no-gutters justify="center" align="center" class="py-4">
        <v-icon color="accent" style="font-size: 60px;">mobile_off</v-icon>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="py-6 text-h5 text-center">
        Indeego n'est pas fait pour fonctionner sur une taille d'écran si petite.
      </v-row>
      <v-row no-gutters justify="center" align="center" class="py-6 text-h6 text-center">
        Si vous êtes sur mobile profitez de notre application sur Android ou iOS.
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-2 pb-4">
        <a href="https://apps.apple.com/us/app/indeego/id1564414006" target="_blank">
          <img src="@/assets/img/available-on-appstore.png" style="max-height: 70px;" />
        </a>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-2 pb-4">
        <a href="https://play.google.com/store/apps/details?id=app.indeego.indeego" target="_blank">
          <img src="@/assets/img/available-on-playstore.png" style="max-height: 70px;" />
        </a>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-12">
        <a @click="forceDeviceTooSmall" class="n-text-btn">
          Afficher l'application malgré tout
        </a>
      </v-row>
    </div>
  </v-row>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations(`ui/mainLayout`, [
      `SET_FORCE_DEVICE_TOO_SMALL`,
    ]),
    forceDeviceTooSmall() {
      this.SET_FORCE_DEVICE_TOO_SMALL(true);
    },
  },
};
</script>
